import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthlessLandingpageService {
  constructor(private http: HttpClient) { }

  getServerInfo(): Observable<{
    timestamp: number;
    time: string;
    instance: string;
  }> {
    const response = this.http.get<{
      timestamp: number;
      time: string;
      instance: string;
    }>(this.apiUrl('server-info'));
    return response;
  }

  apiUrl(endpoint: string, version: string = 'v1'): string {
    const host: string = environment.apiEndpoint;
    const url = `${host}/${endpoint}`;
    return url;
  }
}
